import React from "react";
import { SparklesIcon } from "lucide-react";

interface GenerateLoadingModalProps {
  isOpen: boolean;
  onClose?: () => void;
}

export const GenerateLoadingModal: React.FC<GenerateLoadingModalProps> = ({
  isOpen,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Icon with animation */}
          <div className="relative">
            <div className="w-16 h-16 bg-gradient-to-r from-[#6b2cfe] to-[#0217ff] rounded-full flex items-center justify-center">
              <SparklesIcon className="w-8 h-8 text-white animate-pulse" />
            </div>
            {/* Pulse effect */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#6b2cfe] to-[#0217ff] animate-ping opacity-20"></div>
          </div>

          {/* Loading text */}
          <div className="text-center">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Generate Hasil
            </h3>
            <p className="text-gray-600">Sedang memproses permintaan Anda...</p>
          </div>

          {/* Loading dots animation */}
          <div className="flex space-x-2">
            <div className="w-2 h-2 bg-[#6b2cfe] rounded-full animate-bounce"></div>
            <div
              className="w-2 h-2 bg-[#6b2cfe] rounded-full animate-bounce"
              style={{ animationDelay: "0.1s" }}
            ></div>
            <div
              className="w-2 h-2 bg-[#6b2cfe] rounded-full animate-bounce"
              style={{ animationDelay: "0.2s" }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};
